export class ValidateExportJob {

  constructor(
    public jobId?: number, public customerId?: string
  ) {
  }
}
